import React from 'react';
import { Avatar } from './Avatar';

export const EmployeeAvatarGroup = ({ employees, max = 3, size = 'sm', onClick }) => {
  if (!Array.isArray(employees) || employees.length === 0) return null;

  const visibleEmployees = employees.slice(0, max);
  const excess = employees.length - max;

  return (
    <div 
      className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
      onClick={onClick}
      title={employees.map(e => `${e.firstName} ${e.lastName}`).join(', ')}
    >
      <div className="flex -space-x-2">
        {visibleEmployees.map((emp, index) => (
          <Avatar 
            key={emp._id || index} 
            name={`${emp.firstName} ${emp.lastName}`} 
            size={size} 
            className="ring-2 ring-white"
          />
        ))}
      </div>
      {excess > 0 && (
        <span className="ml-1.5 text-xs font-medium text-gray-500">
          +{excess}
        </span>
      )}
    </div>
  );
};
